import React from "react";

const DocumentSurvey = ({appointment, patient}) => {
    const getBooleanRepresentation = (bool) => (bool === true || bool === "Oui") ? "oui" : "non";

    const renderLastValuePair = (label, value, isBoolean) => (
        <div style={{display: "flex", flexDirection: "row", marginBottom: 5}}>
            {isBoolean ? (
                <>
                    <h5 style={{width: 80, margin: 0,}}>{label}</h5>
                    <h5 style={{
                        width: 20, margin: 0, display: "inline",
                        fontWeight: getBooleanRepresentation(value) === "oui" ? 'bold' : 'normal'
                    }}>
                        {getBooleanRepresentation(value)}
                    </h5>
                </>
            ) : (
                <>
                    <h5 style={{width: 100, margin: 0, marginLeft: 200,}}>
                        {label}
                    </h5>
                    <h5 style={{
                        width: 20, margin: 0, display: "inline", paddingRight: 150, paddingLeft: 20,
                        fontWeight: getBooleanRepresentation(value) === "oui" ? 'bold' : 'normal'
                    }}>
                        {getBooleanRepresentation(value)}
                    </h5>
                </>
            )}
        </div>
    );

    const renderDrugs = () => {
        if (!patient.drugs?.length) return null;
        return <h5 style={{marginBlock: patient.drugs.length !== 0 ? 15 : 0}}>
                <b>Médicaments utilisés : </b>
                {patient.drugs.map((drug, index) => (
                    <h5 style={{marginTop: 5, marginBottom: 0}} key={index}>{drug.label}</h5>
                ))}
            </h5>
    }

    return <>
        {/*Questionnaire*/}
        <h5 style={{marginTop: 20, marginBottom: 5}}><b>Questionnaire :</b></h5>
        <div style={{ display: "flex", flexDirection: "column", flexWrap: "wrap", paddingRight: 40 }}>
            {Object.entries(appointment.report)
                .filter(([key, value]) => !key.includes('#'))
                .filter(([key, value]) => key !== "Diabète ")
                .map(([key, value]) => (
                    <div key={key} style={{ display: "flex", flexDirection: "row", marginRight: 20 }}>
                        <h5 style={{ margin: 0, paddingRight: 5 }}>{key}</h5>
                        <h5
                            style={{
                                width: 20,
                                margin: 0,
                                display: "inline",
                                fontWeight: getBooleanRepresentation(value) === "oui" ? 'bold' : 'normal'
                            }}
                        >
                            {getBooleanRepresentation(value)}
                        </h5>
                    <br/>
                    </div>
                ))}
        </div>
        {/*Antécédents familiaux*/}
        <h5 style={{marginBottom: 5, marginTop: 20}}><b>Antécédents familiaux :</b></h5>
        <div style={{display: "flex", flexDirection: "row", paddingRight: 40}}>
            {renderLastValuePair('Diabète', appointment.report['Diabète '], true)}
            {renderLastValuePair('Glaucome', appointment.report["Glaucome"], false)}
        </div>
        {renderDrugs()}
    </>
}

export default DocumentSurvey;